module.exports = __webpack_public_path__ + "media/images/home-banners/beach-4301479_1920-bb7b99d26c7ce855210bb2facf591d34.jpg";